<template>
  <el-dialog width="520px"  title="修改个人资料" :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="editPersonalVisible">
    <div class="details" v-loading="loading">
      <div >
        <el-form    size="small" ref="currencyForm"   v-loading="loading"    label-position="right"   label-width="80px"  :model="currencyForm"  :rules="currencyFormRules">

          <el-form-item label="头像" prop="avatar">
<!--            <div class="flex_wrap">-->
<!--              <el-avatar :size="80" class="user_avatar" icon="el-icon-user-solid"  v-if="!currencyForm.avatar||currencyForm.avatar==='/Public/images/default.jpg'">-->
<!--              </el-avatar>-->
<!--              <el-avatar :size="80" :src="currencyForm.avatar" :key="currencyForm.avatar" :fit="'fill'" class="user_avatar"  v-else>  </el-avatar>-->
<!--              <el-upload action="" :show-file-list="false" :auto-upload="false" :on-change="handleClickUploadAvatar">-->
<!--                <el-button size="mini" type="primary">上传头像</el-button>-->
<!--              </el-upload>-->
<!--            </div>-->

            <div class="head_img">
              <div class="hover_box">修改头像</div>
              <el-upload action="" :show-file-list="false" :auto-upload="false" :on-change="handleClickUploadAvatar"></el-upload>
              <img :src="currencyForm.avatar ? currencyForm.avatar :'https://download.hecoos.com/enlightv/2024-33/HZHxfRWpzAKjx5Crb3AM.jpg'" alt="">
            </div>
          </el-form-item>

          <el-form-item label="姓名" prop="name" >
            <el-input type="text" v-model="currencyForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>

        </el-form>
      </div>
    </div>
    <div slot="footer">
      <el-button size="small"  :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button  size="small" type="primary"  :disabled="BtnDisabled" @click="handleClickConfirm">确认</el-button>
    </div>

    <el-dialog title="修改头像" :visible.sync="editAvatarDialog" width="50%" append-to-body :close-on-click-modal="false">
      <Cropper :Avatarfile="Avatarfile" :editAvatarDialog.sync="editAvatarDialog" @change="getCropper"
               v-if="editAvatarDialog"/>
    </el-dialog>
  </el-dialog>
</template>
<script>

import { adminPersonalDetail ,adminPersonalEdit} from '@/api/api'
import {mapState} from "vuex";
import { uploadImg, getOSSData } from '@/utils/uploadOss'
import { VueCropper } from 'vue-cropper'
import Cropper from '@/components/Cropper'
export default {
  name: 'admin_edit_personal',
  props: {
    editPersonalVisible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Cropper
  },
  data() {
    return {
      loading:false,
      BtnDisabled: false,
      currencyForm:{
        avatar:'',
        name:'',
      },
      currencyFormRules:{
        name:[{ required: true, message: '请输入姓名', trigger: 'blur'}],
      },

      editAvatarDialog: false,
      Avatarfile: ''
    }
  },

  created() {
    this.getUserDetail()
  },
  computed: {
    ...mapState(['webUserInfo']),
  },
  mounted() {

  },
  methods: {
    // 获取用户信息
    getUserDetail () {
      this.loading = true
      adminPersonalDetail().then(res => {
        if (res.code === 200) {
          const { data } = res
          this.currencyForm.avatar = data.avatar
          this.currencyForm.name = data.name
        }
        this.loading = false
      })
    },
    // 获取裁剪过的头像
    getCropper (data) {
      console.log(data);
      this.currencyForm.avatar = data
    },
    //点击上传头像
    handleClickUploadAvatar (file) {
      var _this = this
      var reader = new FileReader()
      reader.readAsDataURL(file.raw)
      reader.onload = function () {
        _this.Avatarfile = this.result
        _this.editAvatarDialog = true

      }

    },
    handleClickConfirm(){
      this.$refs.currencyForm.validate(valid => {
        if (valid) {
          let postData = {
            avatar:this.currencyForm.avatar,
            name:this.currencyForm.name
          }
          this.BtnDisabled = true
          adminPersonalEdit(postData).then(res => {
            if (res.code === 200) {
              this.$message({
                message:'修改成功',
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.BtnDisabled = false
                  this.$emit('success')
                  this.$emit('update:editPersonalVisible', false)
                }
              })
            }else{
              this.BtnDisabled = false
            }
          }).catch((e) => {
            this.BtnDisabled = false
          })
        }
      })
    },


    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:editPersonalVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.mt-15{
  margin-top: 15px;
}
.el-select{
  display: block;
}
.head_img{
  width: 64px;
  position: relative;
  div.hover_box{
    display: none;
  }
  &:hover div.hover_box{
    z-index: 9;
    width: 64px;
    height: 64px;
    opacity: 0.4;
    background: rgba(0, 0, 0, 1);
    position: absolute;
    border-radius: 50%;
    display: block;
    color: #fff;
    text-align: center;
    line-height: 64px;
    font-size: 14px;
  }
  img{
    display: block;
    width: 64px;
    height: 64px;
    object-fit: cover;
    border-radius: 50%;
  }
  ::v-deep .el-upload{
    position: absolute;
    width: 64px;
    height: 64px;
    left: 0;
    top: 0;
    z-index: 10;
  }
}

</style>
